module.exports = __webpack_public_path__ + "img/Auto-Reply.a3b9d97f.webp";